export default __webpack_public_path__ + "static/media/DGX-H100.c0d3c94e.png";